// src/context/NotificationContext.js
import React, { createContext, useState, useContext } from "react";
import PropTypes from "prop-types";
import MDSnackbar from "components/MDSnackbar";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    color: "info",
    icon: null,
    title: "",
    dateTime: "",
    content: "",
  });

  const showNotification = ({ color, icon, title, dateTime, content }) => {
    setSnackbar({ open: true, color, icon, title, dateTime, content });
    setTimeout(() => {
      setSnackbar((prev) => ({ ...prev, open: false }));
    }, 2000);
  };

  const hideNotification = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <NotificationContext.Provider value={{ snackbar, showNotification, hideNotification }}>
      {children}
      {snackbar.open && (
        <MDSnackbar
          color={snackbar.color}
          icon={snackbar.icon}
          title={snackbar.title}
          dateTime={snackbar.dateTime}
          content={snackbar.content}
          close={hideNotification}
          open={snackbar.open}
        />
      )}
    </NotificationContext.Provider>
  );
};

NotificationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useNotification = () => useContext(NotificationContext);
